export function SignIn() {
  return (
    <div
      className="scrim gm-in"
      style={{ alignItems: "center", background: "var(--gm-bg)", position: "static", height: "100%" }}
    >
      <div
        className="card card-raised gm-in"
        style={{ width: 380, marginTop: 0, padding: 22.4, display: "flex", flexDirection: "column", gap: 16.8, alignItems: "center", textAlign: "center" }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            border: `1px solid var(--gm-accent-deep)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 20,
            fontWeight: 600,
            color: "var(--gm-accent-bright)",
          }}
        >
          G
        </div>
        <div>
          <div style={{ fontSize: 15, fontWeight: 500, letterSpacing: "-0.01em" }}>GeerMail</div>
          <div style={{ fontSize: 12, color: "var(--gm-text-3)", marginTop: 4 }}>
            Sign in with your @geertech.net Google account.
          </div>
        </div>
        <a href="/auth/login" className="btn btn-primary btn-block" style={{ justifyContent: "center" }}>
          Continue with Google
        </a>
      </div>
    </div>
  );
}
